import React from 'react';
import { FileText } from 'lucide-react';
import { ThemedText } from '../../../components';

export default function FileListValue({ value, field, attachments, emptyValue = '—', theme }) {
  const fieldKey = field?.id || field?.key;
  const fieldAttachments = attachments?.filter(
    a => a.fieldName === fieldKey && (a.type === 'Document' || a.type === 'File')
  ) || [];

  const files = fieldAttachments.length > 0
    ? fieldAttachments
    : (Array.isArray(value) ? value : []);

  if (files.length === 0) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>{emptyValue}</ThemedText>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {files.map((file, i) => {
        const url = file.url || file.fileUrl || file;
        const name = file.fileName || file.name || `File ${i + 1}`;
        return (
          <a key={i} href={url} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 4, color: theme?.colors?.primary }}>
            <FileText size={14} />
            {name}
          </a>
        );
      })}
    </div>
  );
}
